import { bw } from './base/bw';
import { hrb } from './base/hrb';
import { bxc } from './base/bxc';
import { jd } from './base/jd';
import { abiBud } from './base/abiBud';
import { abiHrb } from './base/abiHrb';
import { ecco } from './base/ecco';

export const comm = {
  // fontFamily: ['Tahoma', 'Arial', 'Hiragino Sans GB', 'simsun', 'sans-serif'],
  // fontFamily: [
  //   'Lucida Sans',
  //   'Lucida Sans Regular',
  //   'Lucida Grande',
  //   'Lucida Sans Unicode',
  //   'Geneva',
  //   'Verdana',
  //   'sans-serif',
  // ],
  // fontFamily: ['Source Han Sans CN', 'Arial', 'sans-serif'],
  // 图表字体更改
  fontFamily: ['CenturyGothic-Bold, Century Gothic', 'SourceHanSansCNRegular'],
  // fontFamily: ['bwEnFont', 'bwCnFont'],
  fontSize: {
    s01: '10px',
    s02: '12px',
    s03: '14px',
    s04: '16px',
    s05: '18px',
  },
  chartsFontSize: {
    s01: 10,
    s02: 12,
    s03: 14,
  },
  color: {
    cffff: '#ffffff',
    c0000: '#000000',
    c0001: '#f3f5f5',
    c0002: '#8c8c8c',
  },
};
export const base = {
  bud: {
    ...bw,
  },
  hrb: {
    ...hrb,
  },
  bxc: {
    ...bxc,
  },
  'abi-jd': {
    ...jd,
  },
  'abi-bud': {
    ...abiBud,
  },
  'abi-hrb': {
    ...abiHrb,
  },
  ecco: {
    ...ecco,
  },
};
